import { message } from "antd";
import axios from "axios";
import { errorActions } from "../helpers/auth_helper";

export const mdCategories = () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/category-dashboard/`, {
      headers: {
        Authorization: undefined,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      errorActions(error, "Error occured");
      return;
    });
};

export const uploadFile = (formData: FormData) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/project-files/`, formData)
    .then((res) => {
      let item_image = res?.data?.file;
      message.success("Files Upload Successfully !");
      return item_image;
    })
    .catch((e) => {
      console.log("e", { e });
      message.error("Something went wrong!");
    });
};

export const getAddressFromPincode = (pincode: any) => {
  return axios
    .get("https://api.postalpincode.in/pincode/" + pincode, {
      headers: {
        Authorization: undefined,
      },
    })
    .then((res) => {
      if (res?.data[0]?.Status == "Success") {
        let address: any = res.data[0]?.PostOffice[0];
        return {
          name: address?.Name,
          address:
            address?.Name + " " + address?.Block + " " + address?.District,
          state: address?.State,
          city: address?.District,
          country: address?.Country,
          pincode: address?.pincode,
        };
      } else {
        return false;
      }
    })
    .catch((error) => {
      errorActions(error, "Error occured");
      return;
    });
};

export const getLatLongFromGooGlLink = async (link: any) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/lat-long-from-link/`,
      {
        params: { link: link },
      }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const importLoginextTrip = async (tripNames: string[]) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/import-loginext-trips/`,
      { trip_names: tripNames }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const pushTripToPidge = async (tripId: number | string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/push-to-pidge-from-trip/`,
      {
        params: { trip_id: tripId },
      }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const pushTripToPidgeWithName = async (tripName: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/push-to-pidge-from-trip/`,
      {
        params: { trip_name: tripName },
      }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const getDeliveries = async (params: any) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/po-deliveries/`,
      {
        params: { ...params },
      }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const createDelivery = async (data: any) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/po-deliveries/`,
      data
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const editDelivery = async (data: any) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/po-deliveries/`,
      data
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const uploadImage = async (formData: FormData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/image-upload/`,
      formData
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const fetchCashLog = async (params: any) => {
  try {
    return axios
      .get(
        `${process.env.REACT_APP_API_URL}/estimate-payment-transaction-cashlog/`,
        {
          params: { ...params },
        }
      )
      .then((res) => {
        // console.log(res.status, "this is the response");

        return res?.data;
      })
      .catch((error) => {
        if (error) {
          console.log("error found");
          errorActions(
            error,
            "Error fetching cash log. Please check and try again"
          );
          return;
        }
      });
  } catch (error) {}
};

// apiV1/cashlog-summary-by-branch/
export const fetchCashLogSummaryByBranch = async (params: any = {}) => {
  try {
    return axios
      .get(
        `${process.env.REACT_APP_API_URL}/cashlog-summary-by-branch/`,
        {
          params: { ...params },
        }
      )
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        if (error) {
          errorActions(
            error,
            "Error fetching cash log. Please check and try again"
          );
          return;
        }
      });
  } catch (error) {}
};

// apiV1/cashlog-grouped-by-user/
export const fetchCashLogGroupedByUser = async (params: any = {}) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/cashlog-grouped-by-user/`, {
        params: { ...params },
      })
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        if (error) {
          errorActions(
            error,
            "Error fetching cash log. Please check and try again"
          );
          return;
        }
      });
  } catch (error) {}
};

export const depositCashLog = async (data: any) => {
  try {
    return axios
      .post(
        `${process.env.REACT_APP_API_URL}/estimate-payment-transaction-cashlog/`,
        data
      )
      .then((res) => {
        // console.log(res.status, "this is the response");

        return res?.data;
      })
      .catch((error) => {
        if (error) {
          console.log("error found");
          errorActions(
            error,
            "Error inserting into cash log. Please check and try again"
          );
          return;
        }
      });
  } catch (error) {}
};

export const createPOF = async (formData: FormData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/create-pof/`,
      formData
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const listPOF = async (po_delivery_id: number) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/list-pof/`,
      { params: { po_delivery_id } }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const deletePOF = async (proof_id: number) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/delete-pof/`,
      { data: { proof_id } }
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

